import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=75d1ec65"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports